import React, { forwardRef, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import withTheme from '../styles/withTheme'
import RadioGroupContext from '../RadioGroup/RadioGroupContext'

import './Rf-radio.scss'

const Radio = forwardRef(function Radio(props, ref) {
	const {
		checked: checkedProp,
		className,
		disabled,
		inputRef,
		name: nameProp,
		onChange,
		onCheckedChange,
		...other
	} = props

	const radioGroup = useContext(RadioGroupContext)
	let checked = checkedProp
	const handleChange = (event) => {
		onChange && onChange(event)
		radioGroup && radioGroup.onChange(event)
	}
	let name = nameProp

	if (radioGroup) {
		if (typeof checked === 'undefined') {
			checked = radioGroup.value === props.value
		}
		if (typeof name === 'undefined') {
			name = radioGroup.name
		}
	}

	useEffect(() => {
		onCheckedChange && onCheckedChange(checked)
	}, [checked])

	return (
		<span ref={ref} className="Vb-radio__wrapper">
			<input
				ref={inputRef}
				type="radio"
				className={clsx('Vb-radio', className)}
				name={nameProp}
				checked={checked}
				onChange={handleChange}
				disabled={disabled}
				{...other}
			/>
		</span>
	)
})

export default withTheme('Vb-radio')(Radio)

Radio.propTypes = {
	/**
	 * The content of the button.
	 */
	children: PropTypes.node,

	/**
	 * If `true`, the component is checked.
	 */
	checked: PropTypes.bool,

	/**
	 * If `true`, the component is disabled.
	 */
	disabled: PropTypes.bool,

	/**
	 * Callback fired when the state is changed.
	 *
	 * @param {object} event The event source of the callback.
	 * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	 */
	onChange: PropTypes.func,
	/**
	 * The value of the component. The DOM API casts this to a string.
	 */
	value: PropTypes.any
}
